// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kViR","left":"styles_left__2j5FE","desktopActions":"styles_desktopActions__3oKuj","title":"styles_title__2Nxlz"};